import { render, staticRenderFns } from "./TableSortAndFilterElement.vue?vue&type=template&id=54500f5e"
import script from "./TableSortAndFilterElement.vue?vue&type=script&lang=js"
export * from "./TableSortAndFilterElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports